$('input[type="file"]').on("change", function(event) {
  var file = this.files[0];
  fileName = file.name;
  $(this).parent().next('.input-description').text(fileName).addClass('file-name');
});

$('input[name=busqueda_frecuente]').click(function(){
  $( "#filtros-form" ).submit();
});
